/**
 * A class to handle requests to /api/kernelspecs
 */
export class KernelSpecs {
    constructor() {
        this._specs = new Map();
        this._factories = new Map();
    }
    /**
     * Get the kernel specs.
     */
    get specs() {
        if (this._specs.size === 0) {
            return null;
        }
        return {
            default: 'python',
            kernelspecs: Object.fromEntries(this._specs),
        };
    }
    /**
     * Get the kernel factories for the current kernels.
     */
    get factories() {
        return this._factories;
    }
    /**
     * Register a new kernel.
     *
     * @param options The options to register a new kernel.
     */
    register(options) {
        const { spec, create } = options;
        this._specs.set(spec.name, spec);
        this._factories.set(spec.name, create);
    }
}
